/* eslint-disable no-unused-vars */
/* eslint-disable */
// var max = 480,
//     min = 9; // todo 
// var maxSize4Pin = 100,
//     minSize4Pin = 10;
// const data = [
//   { name: '广东', value: 5 },
//   { name: '福建', value: 1 },
//   { name: '湖南', value: 3 },
//   { name: '上海', value: 2 },
//   { name: '河南', value: 1 },
//   { name: '江西', value: 1 },
// ];
const data = [
  { name: '广东', value: 5000 },
  { name: '福建', value: 1000 },
  { name: '湖南', value: 3 },
  { name: '上海', value: 2 },
  { name: '河南', value: 1 },
  { name: '江西', value: 1 },
];
export const geoCoordMap = {
  上海: [121.48054, 31.235929],
  福建: [119.4543, 25.9222],
  重庆: [108.384366, 30.439702],
  北京: [116.4551, 40.2539],
  辽宁: [123.1238, 42.1216],
  河北: [114.4995, 38.1006],
  天津: [117.4219, 39.4189],
  山西: [112.3352, 37.9413],
  陕西: [109.1162, 34.2004],
  甘肃: [103.5901, 36.3043],
  宁夏: [106.3586, 38.1775],
  青海: [101.4038, 36.8207],
  新疆: [87.9236, 43.5883],
  西藏: [91.11, 29.97],
  四川: [103.9526, 30.7617],
  吉林: [125.8154, 44.2584],
  山东: [117.1582, 36.8701],
  河南: [113.4668, 34.6234],
  江苏: [118.8062, 31.9208],
  安徽: [117.29, 32.0581],
  湖北: [114.3896, 30.6628],
  浙江: [119.5313, 29.8773],
  内蒙古: [110.3467, 41.4899],
  江西: [116.0046, 28.6633],
  湖南: [113.0823, 28.2568],
  贵州: [106.6992, 26.7682],
  云南: [102.9199, 25.4663],
  广东: [113.12244, 23.009505],
  广西: [108.479, 23.1152],
  海南: [110.3893, 19.8516],
  黑龙江: [127.9688, 45.368],
  台湾: [121.4648, 25.5630],
  香港: [114.186125, 22.293586],
  澳门: [113.551589, 22.19316]
};

// eslint-disable-next-line no-shadow
export const convertData = (data) => {
  const res = [];
  for (let i = 0; i < data.length; i++) {
    let name = data[i].name;
    let formatName = '';
    switch(name) {
      case '宁夏回族自治区':
        formatName = '宁夏';
        break;
      case '新疆维吾尔自治区':
        formatName = '新疆';
        break;
      case '西藏自治区':
        formatName = '西藏';
        break;
      case '内蒙古自治区':
        formatName = '内蒙古';
        break;
      case '广西壮族自治区':
        formatName = '广西';
        break;
      case '香港特别行政区':
        formatName = '香港';
        break;
      case '澳门特别行政区':
        formatName = '澳门';
        break;
      case '台湾省':
        formatName = '台湾';
        break;
      case '其它':
        formatName = '广东';
        break;
      default:
        if (name.indexOf('省')>-1 || name.indexOf('市')>-1) {
          formatName = name.substring(0, name.length -1);
        } else {
          formatName = name;
        }
        break;
    }
    
    const geoCoord = geoCoordMap[formatName];
    if (geoCoord) {
      res.push({
        name: formatName,
        value: geoCoord.concat(data[i].value)
      });
    }
  }
  return res;
};

/**
* priority  tooltip朝向（top/bottom）
* left, top 为默认值
* 根据展示内容需要微调text的宽高
*/
let left = false, 
  top = false, 
  // eslint-disable-next-line prefer-const
  priority = 'top';
// 自定义tooltip配置属性
const config = {
  ecBoxId: 'chart-panel',
  lineColor: '#FFAA29',
  L1: {
    time: 0.3,
    long: 40
  },
  L2: {
    time: 0.3,
    long: 40
  },
  text: {
    time: 0.5,
    text: '',
    font: '14px Arial',
    color: '#fff',
    padding: [10, 10],
    width: 120,
    height: 60,
    lineHeight: 24,
    backgroundColor: 'rgba(229, 140, 54, 0.8)'
  }
};

const canvasAnimation = (params) => {
  setTimeout(() => {
    config.text.text = `地点：${params.name}\n数量：${params.value[2]}`;
    // eslint-disable-next-line no-new
    new myTooltip('tCanvas', config);
  }, 0);
};

// 计算tooltip位置
const getPosOrSize = (type, point) => {
  const x1 = config.L1.long * Math.sin(Math.PI / 4);
  const width = x1 + config.L2.long + config.text.width,
    height = x1 + config.text.height / 2;
  if (type === 'size') {
    config.width = width;
    config.height = height;
    return {
      width,
      height
    };
  } 
  let box = document.getElementById(config.ecBoxId),
    bw = box.offsetWidth,
    bh = box.offsetHeight,
    x = point[0],
    y = point[1];
  left = false;
  if (x + width >= bw / 1.2) {
    x = x - width - 5;
    left = true;
  }
  if (priority === 'top') {
    // L1向上
    top = true;
    y = y - height - 5;
    if (y <= 0) {
      y = point[1];
      top = false;
    }
    return [x, y];
  } 
  top = false;
  if (y + height >= bh) {
    y = y - height - 5;
    top = true;
  }
  return [x, y];
      
  
};

class myTooltip {
  constructor(id, config) {
    this.config = config;
    this.totalTime = 0;
    this.stage = new createjs.Stage(id);
    this.timeline = new TimelineMax({ repeat: 0 });
    this.g = new createjs.Graphics();
    this.lineShape = new createjs.Shape(this.g);
    this.textShape = new createjs.Shape();
    this.stage.addChild(this.lineShape, this.textShape);
    this.init();
    this.begin();
    this.update();
  }

  init() {
    this.start = [0, 0];
    if (left) {
      this.start[0] = this.config.width; 
    }
    if (top) {
      this.start[1] = this.config.height;
    }
  }

  begin() {
    this.L1();
    this.L2();
    this.addText();
  }

  L1() {
    const me = this;
    const c = me.config;
    const tl = new TimelineMax();
    const scale = { s: 0 },
      x = c.L1.long * Math.sin(Math.PI / 4);
    if (left) {
      if (top) {
        this.L1End = [me.start[0] - x, me.start[1] - x];
      } else {
        this.L1End = [me.start[0] - x, me.start[1] + x];
      }
    } else if (top) {
      this.L1End = [x, me.start[1] - x];
    } else {
      this.L1End = [x, x];
    }
      
    tl.to(scale, c.L1.time, {
      s: 1,
      onUpdate() {
        const { s } = scale;
        if (left) {
          if (top) {
            me.g.c().s(c.lineColor).mt(...me.start).lt(me.start[0] - x * s, me.start[1] - x * s);
          } else {
            me.g.c().s(c.lineColor).mt(...me.start).lt(me.start[0] - x * s, me.start[1] + x * s);
          }
        } else if (top) {
          me.g.c().s(c.lineColor).mt(...me.start).lt(x * s, me.start[1] - x * s);
        } else {
          me.g.c().s(c.lineColor).mt(...me.start).lt(x * s, x * s);
        }
        me.update();
      }
    });
    this.timeline.add(tl, this.totalTime);
    this.totalTime += c.L1.time;
  }

  L2() {
    // 只跟左右有关，只判断left
    const me = this;
    const c = me.config;
    const tl = new TimelineMax();
    const scale = { s: 0 };
    tl.to(scale, c.L2.time, {
      s: 1,
      onUpdate() {
        const { s } = scale;
        if (left) {
          me.g.c().s(c.lineColor).mt(...me.start).lt(...me.L1End)
            .lt(me.L1End[0] - c.L2.long * s, me.L1End[1]);
        } else {
          me.g.c().s(c.lineColor).mt(...me.start).lt(...me.L1End)
            .lt(me.L1End[0] + c.L2.long * s, me.L1End[1]);
        }
        me.update();
      }
    });
    this.timeline.add(tl, this.totalTime);
    this.totalTime += c.L2.time;
  }

  addText() {
    // text框只与L2end有关，只需判断left即可，top不影响
    const me = this;
    const c = me.config;
    const tl = new TimelineMax();
    // eslint-disable-next-line prefer-const
    let scale = { s: 0 },
      L2End = [me.L1End[0] + c.L2.long, me.L1End[1]];
    if (left) {
      L2End = [me.L1End[0] - c.L2.long, me.L1End[1]];
    }
    tl.to(scale, c.text.time, {
      s: 1,
      onStart() {
        let x = 0, 
          y = 0;
        if (left) {
          x = L2End[0] - c.text.width;
        } else {
          x = L2End[0];
        }
        me.g.c().s(c.lineColor).mt(...me.start).lt(...me.L1End)
          .lt(...L2End);
        me.text = new createjs.Text(c.text.text, c.text.font, c.text.color);
        me.text.alpha = 0;
        me.text.lineHeight = c.text.lineHeight;
        me.text.x = x + c.text.padding[0];
        me.text.y = L2End[1] - c.text.height / 2 + c.text.padding[1];
        me.stage.addChild(me.text);
        me.textShape.graphics.c().f(c.text.backgroundColor).rr(x, L2End[1] - c.text.height / 2, c.text.width, c.text.height, 5);
        me.textShape.alpha = 0;
        me.update();
      },
      onUpdate() {
        if (scale.s) {
          me.text.alpha = scale.s;
        }
        me.textShape.alpha = scale.s;
        me.update();
      }
    });
    this.timeline.add(tl, this.totalTime);
  }

  update() {
    this.stage.update();
  }
}

export default {
  tooltip: {
    // show: false,
    trigger: 'item',
    // triggerOn: 'click',
    // backgroundColor: 'transparent',
    // alwaysShowContent: true,
    // position(pos) {
    //   const position = getPosOrSize('pos', pos);
    //   return position;
    // },
    // formatter(params, p, a) {
    //   canvasAnimation(params);
    //   const size = getPosOrSize('size');
    //   const tooltipDom = `<canvas id="tCanvas" width="${size.width}" height="${size.height}"></canvas>`;
    //   return tooltipDom;
    // }
  },
  legend: {
    show: false
  },
  geo: {
    map: 'china',
    label: {
      normal: {
        color: '#fff'
      },
      emphasis: {
        color: '#fff',
        show: false
      }
    },
    zoom: 1,
    scaleLimit: {
      min: 1,
      max: 1
    },
    // center: [116.4551, 40.2539],
    center: [118.186463, 39.636585],
    // center: [126.669656,45.74793],
    roam: false,
    itemStyle: {
      normal: {
        areaColor: '#031525',
        borderColor: '#1773c3',
        borderWidth: 1
      },
      emphasis: {
        areaColor: '#051837'
      }
    },
    regions: []
    // regions: [{
    //   name: '福建',
    //     itemStyle: {
    //       areaColor: '#1676FF',
    //     },   
    // }]
  },
  series: [
    {
      // name: 'Tooltip Test',
      // type: 'effectScatter',
      tooltip: {
        show: false,
      },
      type: 'scatter',
      coordinateSystem: 'geo',
      data: convertData(data.sort((a, b) => b.value - a.value).slice(0, 50)),
      // symbolSize(val) {
      //   return val[2] / 5;
      // },
      symbolSize: 1,
      showEffectOn: 'render',
      rippleEffect: {
        brushType: 'stroke'
      },
      hoverAnimation: true,
      label: {
        normal: {
          formatter: '{b}',
          position: 'bottom',
          show: true
        },
      },
      itemStyle: {
        normal: {
          color: '#ccc',
          shadowBlur: 10,
          shadowColor: '#333'
        },
      },
      zlevel: 1
    },
    {
      name: '新增门店',
      type: 'scatter',
      coordinateSystem: 'geo',
      data: [],
      // symbolSize(val) {
      //   return val[2] / 5;
      // },
      symbolSize: 30,
      symbol: 'pin', //气泡
      // symbol: 'path://M35.025,17.608c-5.209-4.786-11.483-2.301-15.303-4.281v-1.482c0-0.41-0.333-0.743-0.743-0.743c-0.411,0-0.743,0.333-0.743,0.743v24.682c-1.855,0.104-3.261,0.59-3.261,1.175c0,0.661,1.793,1.197,4.005,1.197c2.21,0,4.003-0.536,4.003-1.197c0-0.585-1.405-1.071-3.261-1.175V26.151C24.575,24.573,28.408,17.166,35.025,17.608z',
      // showEffectOn: 'render',
      rippleEffect: {
        brushType: 'stroke'
      },
      hoverAnimation: true,
      label: {
        normal: {
          formatter: function(params) {
            // console.log(params);
            const data = params.data;
            // return `${data.name} ${data.value[2]} 家`;
            return `${data.value[2]}`;
          },
          // position: 'bottom',
          show: true
        }
      },
      itemStyle: {
        normal: {
          color: '#F62157',
          // shadowBlur: 10,
          // shadowColor: '#fff',
          label: {
            fontSize: 12,
            fontWeight: 'bold',
            // textShadowColor: '#fff',
            // textShadowBlur: 10,
            // textBorderColor: '#fff',
            // textBorderWidth: 1
          }
        }
      },
      tooltip: {
        formatter: function(params) {
          // console.log(params)
          const data = params.data;
          // return `${data.name}:${data.value[2]}`;
          return `${data.name} 今日新增门店 ${data.value[2]} 家`;
        },
        textStyle: {
          fontSize: 12
        },
        backgroundColor: 'rgba(246, 33, 87,.8)',
      },
      zlevel: 1
    },
    {
      name: '销售金额',
      type: 'scatter',
      coordinateSystem: 'geo',
      // symbol: 'pin', //气泡
      // symbol: 'path://M35.025,17.608c-5.209-4.786-11.483-2.301-15.303-4.281v-1.482c0-0.41-0.333-0.743-0.743-0.743c-0.411,0-0.743,0.333-0.743,0.743v24.682c-1.855,0.104-3.261,0.59-3.261,1.175c0,0.661,1.793,1.197,4.005,1.197c2.21,0,4.003-0.536,4.003-1.197c0-0.585-1.405-1.071-3.261-1.175V26.151C24.575,24.573,28.408,17.166,35.025,17.608z',
      symbolSize: 5,
      label: {
        normal: {
          show: true,
          textStyle: {
            color: '#FFAA29',
            fontSize: 13,
            fontWeight: 'bold'
          },
          position: 'top',
          formatter: function(params) {
            // console.log(params)
            const data = params.data;
            // return `${data.name} 新增门店 ${data.value[2]} 家`;
            return `+ ${data.value[2]} 元`
          },
        },
      },
      // tooltip: {
      //   formatter: function(params) {
      //     // console.log(params)
      //     const data = params.data;
      //     // return `${data.name} 新增门店 ${data.value[2]} 家`;
      //     return `销售金额 ${data.value[2]} 元`
      //   },
      //   position: 'top',
      //   // backgroundColor: 'rgba(22, 118, 255, 0.8)',
      //   backgroundColor: 'rgba(246, 33, 87,.8)',
      //   textStyle: {
      //     fontSize: 12
      //   }
      // },
      itemStyle: {
        normal: {
          color: '#fff'
          // color: '#1676FF'
          // color: '#F62157', //标志颜色
        }
      },
      zlevel: 6,
      data: [],
    },
  ]
};
